export const MessageLink = ({ websiteSectionList }) => {
  const linkComponents = websiteSectionList?.map((item, index) => (
    <div key={index} className="max-w-[91px]">
      <p className="cursor-pointer text-[14px] font-bold text-[#333]">{item.sectionName}</p>
      <ul data-spm={`msg${index + 1}`} className="mt-[16px]">
        {item.articleList.map((val, i) => (
          <li key={index + i} className="mb-[10px] text-[12px] text-[#666] last:mb-0">
            {val.name !== '加入收藏' ? (
              <a
                data-spm={`${i + 1}`}
                target="_blank"
                rel="nofollow"
                href={`${val.link}`}
                className="hover:text-[#0095E7]"
              >
                {val.articleTitle}
              </a>
            ) : (
              <button className="hover:text-[#0095E7]">{val.articleTitle}</button>
            )}
          </li>
        ))}
      </ul>
    </div>
  ));

  return (
    <div className="mx-auto flex w-[1200px]">
      <div className="flex justify-between w-[782px] border-r border-solid border-[#DEE0E2] pr-[60px]">
        {linkComponents}
      </div>
      <div className="w-[418px] pl-[60px] flex justify-between">
        <ul className="text-[#666666]">
          <p className="cursor-pointerpointer whitespace-nowrap text-[14px] font-bold text-[#333]">联系我们</p>
          <li className="mt-[16px] whitespace-nowrap text-[12px] text-[#666]">
            服务热线：
            <span className="font-bold text-[#333]">0755-83865666</span>
          </li>
          <li className="mt-[10px] whitespace-nowrap text-[12px] text-[#666]">
            企业QQ&nbsp;：<span>4000800709</span>
          </li>
          <li className="mt-[10px] flex text-[12px] text-[#666]">
            <span className="whitespace-nowrap">服务时间：</span>
            <ul>
              <li className="whitespace-nowrap">8:30-18:30（工作日）</li>
              <li className="whitespace-nowrap">9:00-18:00（节假日）</li>
            </ul>
          </li>
        </ul>
        <div className="text-center">
          <img
            src="https://wsimg.szlcsc.com/upload/public/brand/logo/20240218/EE881C71F897180B5BA557754EFDDF1D.png"
            alt="关注立创商城公众号"
            width={128}
            height={128}
            className="rounded-[8px]"
          />
          <p className="mt-[9px] whitespace-nowrap text-[12px] text-[#333]">关注立创商城公众号</p>
        </div>
      </div>
    </div>
  );
};
